import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dataColumn, dataModColumn } from '../../../../components/DataColumn'
import EditableDataGrid from '../../../../components/DataGrid/EditableDataGrid'
import { updatebidsRowsDetailsSlice } from '../../../../store/slice/bidsSlice'
import { createPrivileges } from '../../../../store/slice/buttonSlice'
import DialogWrapper from '../DialogWrapper'
import {
  autocompleteSelectColumn,
  autocompleteSelectColumnCondition,
  columnConversion,
  columnEditableForRow,
  dialogColumn,
  puomColumn,
} from '../columns'
import { calculateBidsRow } from '../helper'

import { Icon } from '@iconify/react'
import { IconButton } from '@mui/material'
import { isEmpty } from 'lodash'
import { conditions } from '../../../../constDatas/constDatas'
import Table from '../../../../helpers/table'
import { useGetBIDsAttachmentsQuery } from '../../../../store/api/bidsApi'
import { toggleUploadDialog } from '../../../../store/slice/dialogSlice'
import { discountTypeList } from '../constants'
import { useTranslation } from 'react-i18next'

const BIDsCardList = ({ data, disabled, formIsDisabled, businessUnitId, businessUnitCode, bidsDataLoading, totalDiscountedAmount, setTotalDiscountedAmount }) => {
  const { t } = useTranslation('bid')
  const dynamicKey = data?.[0]?.bidDetailId ? 'bidDetailId' : data?.[0]?.rfqDetailId ? 'rfqDetailId' : 'id'
  const dispatch = useDispatch()

  const [rowParams, setRowParams] = useState()
  const addRowReqPrivileges = useSelector((state) => state.buttonSlice.createData)

  if (disabled) {
    dispatch(createPrivileges())
  }

  useEffect(() => {
    dispatch(updatebidsRowsDetailsSlice(data))
    setTotalDiscountedAmount(data?.reduce((acc, row) => acc + (row.discountedAmount || 0), 0))

  }, [dispatch, data])

  const handleCellEdit = (params) => {
    if (params.field === 'alternativeItem') {
      const rows = data.map((item) => {
        if (item[dynamicKey] === params.id) {
          return { ...item, alternativeItem: params.value }
        }

        return item
      })

      dispatch(updatebidsRowsDetailsSlice(rows))
      return
    }

    if (params.field === 'puom') {
      const rows = data.map((item) => {
        if (item[dynamicKey] === params.id) {
          return { ...item, puom: params.value.puom, conversionRate: params.value.conversionRate }
        }

        return item
      })

      dispatch(updatebidsRowsDetailsSlice(rows))
      return
    }

    if (params.field === 'condition') {
      const rows = data.map((item) => {
        if (item[dynamicKey] === params.id) {
          return { ...item, condition: { conditionValue: params?.value ?? 0, disabled: false } }
        }

        return item
      })

      dispatch(updatebidsRowsDetailsSlice(rows))
      return
    }

    const rows = data.map((item) => {
      if (item[dynamicKey] === params.id) {
        return calculateBidsRow(item, params)
      }

      return item
    })

    dispatch(updatebidsRowsDetailsSlice(rows))
  }

  const [isOpen, setIsOpen] = useState(false)

  const handleDialog = (props) => {
    setRowParams(props)
    setIsOpen(true)
  }

  const [attachments, setAttachments] = useState([])
  const [sourceId, setSourceId] = useState([])
  const { data: attachmentsData, error, refetch } = useGetBIDsAttachmentsQuery({ sourceId })

  const handleRowAttachment = (id) => {

    setSourceId(id)
    dispatch(toggleUploadDialog())
  }

  useEffect(() => {
    refetch()
  }, [sourceId])

  const columns = () => {
    let alternativeItemCode = []
    let alternativeItemName = []
    if (data?.data?.some((item) => item?.alternativeItem)) {
      alternativeItemCode = [dialogColumn('alternativeItemCode', 'Alternative Item Code', 200, handleDialog)]
      alternativeItemName = [
        columnEditableForRow('alternativeItemName', 'Alternative Item Name', 150, 'string', handleCellEdit),
      ]
    }

    return [
      {
        field: 'actions',
        headerName: t('actions'),
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => {
          const isDisabled = isEmpty(params.row.attachments)

          return (
            <IconButton
              disabled={isDisabled}
              sx={{ p: 0 }}
              onClick={() => {
                handleRowAttachment(params.row[dynamicKey])
              }}
            >
              <Icon icon="iconoir:attachment" color={isDisabled ? '#aaa' : 'green'} />
            </IconButton>
          )
        },
      },
      dataModColumn('lineNo', t('line_no'), 70, 'number'),
      dataModColumn('itemCode', t('item_code'), 120, 'string'),
      dataModColumn('description', t('description_requested_item'), 550),

      {
        field: 'alternativeItem',
        headerName: t('alternative_item'),
        width: 80,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => {
          return (
            <input
              disabled="true"
              type="checkbox"
              checked={params?.row?.alternativeItem}
              onChange={(event) => {
                const newValue = event.target.checked
                handleCellEdit({
                  id: params.row?.[dynamicKey],
                  field: 'alternativeItem',
                  value: newValue,
                })
              }}
            />
          )
        },
      },
      ...alternativeItemCode,
      ...alternativeItemName,
      dataModColumn('rfqQuantity', t('rfq_quantity'), 100, 'number'),
      dataModColumn('uom', 'UOM', 100, 'string'),

      puomColumn({
        handleCellEdit,
        disabled: formIsDisabled,
        businessUnitId,
        businessUnitCode,
      }),

      columnConversion('conversionRate', t('conversion'), 100, 'number', handleCellEdit),
      dataModColumn('lineDescription', t('line_description'), 200, 'string', !formIsDisabled),

      autocompleteSelectColumnCondition('condition', t('condition'), 100, handleCellEdit, conditions, 'value', 'label'),

      dataColumn('quantity', t('quantity'), 100, 'number', false),
      // autocompleteSelectColumn(
      //   'discountType',
      //   t('discount_type'),
      //   170,
      //   !formIsDisabled,
      //   handleCellEdit,
      //   discountTypeList,
      //   'discountTypeValue',
      //   'discountTypeName'
      // ),
      // dataColumn('discountValue', t('discount_value'), 100, 'number', !formIsDisabled),
      dataColumn('unitPrice', t('unit_price'), 100, 'number', !formIsDisabled),

      dataModColumn('singleUnitPrice', t('single_unit_price'), 100, 'number', false),
      dataModColumn('totalAmount', t('total_amount'), 100, 'number', !formIsDisabled),
      dataModColumn('discountedAmount', t('discounted_amount'), 150, 'number', !formIsDisabled),

      dataModColumn('convertedQTY', t('converted_quantity'), 120, 'number'),
      dataModColumn('convertedUnitPrice', t('converted_unit_price'), 120, 'number'),
    ]
  }

  const [visibleColumns, setVisibleColumns] = useState(
    Table.generateVisibleFields(columns(), 'BidCardGrid', { id: false })
  )

  useEffect(() => {
    localStorage.setItem('BidCardGrid', JSON.stringify(visibleColumns))
  }, [visibleColumns])

  return (
    <>
      <strong>Total Amount : {totalDiscountedAmount}</strong>
      <EditableDataGrid
        columns={columns}
        data={data}
        dynamicKey={dynamicKey}
        handleCellEdit={handleCellEdit}
        height={380}
        addRowReqPrivileges={addRowReqPrivileges}
        isLoading={bidsDataLoading}
        columnVisibility={visibleColumns}
        setColumnVisibility={setVisibleColumns}
      />

      {isOpen && (
        <DialogWrapper
          isOpen={isOpen}
          businessUnitId={businessUnitId}
          rowParams={rowParams}
          handleClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}

export default BIDsCardList
